<script lang="ts">
    import { onDestroy } from 'svelte';

    export let name: string;
    export let errors: Record<string, string[]>;
    export let label: string = '';
    export let value: number = 50;
    export let min: number = 0;
    export let max: number = 100;
    export let step: number = 1;
    export let disabled: boolean = false;
    export let showValue: boolean = true;

    errors[name] = [];

    onDestroy(() => { errors[name] = []; });

    $: fillPercent = ((value - min) / (max - min)) * 100;
</script>

<label class="form-field">
    <span class="label-text label-text--row">
        {#if label}{label}{/if}
        {#if showValue}<span class="value-badge">{value}</span>{/if}
    </span>
    <input
        type="range"
        {name}
        {min}
        {max}
        {step}
        {disabled}
        bind:value
        style="background-size: {fillPercent}% 6px, 100% 4px"
        on:change
        on:input
    />
    <span class="field-errors">
        {#each errors[name] as err}<span>{err}</span>{/each}
    </span>
</label>

<style lang="scss">
    .label-text--row {
        display: flex;
        gap: 0.5em;
        align-items: center;
    }
</style>
